import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { TIMELINE_RULER_HEIGHT } from '../consts'
import { getPlayHeadWrapperPadding } from 'utils'

export const PlayHeadWrapper = styled.div.attrs<{ $height: number }>(
  ({ $height }) => ({
    style: {
      height: `${$height}px`
    }
  })
)<{ $height: number }>`
  padding-left: ${getPlayHeadWrapperPadding()}px;
  position: absolute;

  inset: 0;
  pointer-events: none;
`

export const PlayHeadArea = styled.div<{ $width: number }>`
  position: relative;
  height: 100%;
  width: ${({ $width }) => $width}px;
`

export const PlayHead = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 100%;
  z-index: 10;
  cursor: grab;
  pointer-events: auto;
  @keyframes playhead-animation {
    0% {
      left: var(--playhead-start, 0);
    }
    100% {
      left: 100%;
    }
  }
  animation-timing-function: linear;
  animation-play-state: pause;
`

export const PlayHeadLine = styled.div`
  position: absolute;
  width: 2px;
  height: 100%;
  background-color: ${COLORS.secondaryDark};
  border-left: 1px solid ${COLORS.white};
  border-right: 1px solid ${COLORS.white};
  box-sizing: content-box;
  transform: translateX(-50%);
`

export const PlayHeadHead = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-50%);
  z-index: 2;
`

export const PlayHint = styled.div`
  position: absolute;
  top: 0;
  height: 100%;
  z-index: 2;
  width: 0;
  border-right: 1px dashed ${COLORS.secondaryDark};
  pointer-events: none;
  display: none;
`

export const PlayHeadClickableArea = styled.div`
  width: 100%;
  height: ${TIMELINE_RULER_HEIGHT}px;
  pointer-events: auto;
`
